<div class="container py-5">
    <h1>Política de Privacidade</h1>

    <p>Além de querermos ter uma relação completamente transparente com você, é essencial que você se sinta confortável
        ao usar nossa plataforma e ao compartilhar seus dados conosco, daí a importância desta política de privacidade.
        Caso não esteja de acordo, não recomendamos a utilização da nossa plataforma.</p>

    <p class="title">Introdução</p>
    <p>O tratamento dos dados pessoais é condição essencial para a utilização da Plataforma Estudei, sendo impossível
        oferecer suas funcionalidades sem o acesso aos dados.</p>
    <p>Esta Política e suas atualizações devem prevalecer sobre todas as propostas, contratos e entendimentos anteriores
        e acordos, orais ou escritos, eventualmente existentes entre as partes. Além disso, como ela está sujeita a
        constantes melhorias e aprimoramentos, recomendamos sua periódica consulta.</p>
    <p>Lembrando que, para menores de idade, a utilização da plataforma deve ser autorizada e realizada sob a supervisão
        dos pais ou responsáveis legais.</p>

    <p class="title">Cookies</p>
    <p>Se você quiser saber quais cookies estão instalados no seu computador ou notebook, ou se deseja
        excluí-los ou restringi-los, você pode utilizar as configurações do seu navegador para isso.
        Você encontrará mais explicações sobre como proceder clicando nos links abaixo:</p>
    <table class="table table-bordered">
        <tr class="text-center">
            <td>
                <a target="_blank"
                    href="https://support.google.com/chrome/answer/95647?co=GENIE.Platform=Desktop&hl=pt-BR">
                    Google Chrome
                </a>
            </td>
            <td>
                <a target="_blank"
                    href="https://support.mozilla.org/pt-BR/kb/limpe-cookies-e-dados-de-sites-no-firefox">
                    Mozilla Firefox
                </a>
            </td>
            <td>
                <a target="_blank"
                    href="https://support.microsoft.com/pt-br/microsoft-edge/excluir-cookies-no-microsoft-edge-63947406-40ac-c3b8-57b9-2a946a29ae09">
                    Microsoft Edge
                </a>
            </td>
            <td>
                <a target="_blank"
                    href="https://support.microsoft.com/pt-br/topic/como-excluir-arquivos-de-cookie-no-internet-explorer-bca9446f-d873-78de-77ba-d42645fa52fc">
                    Internet Explorer
                </a>
            </td>
            <td>
                <a target="_blank" href="https://support.apple.com/pt-br/guide/safari/sfri11471/mac">
                    Apple Safari
                </a>
            </td>
        </tr>
    </table>
    <p>Ao acessar a plataforma, podemos utilizar “Cookies” para reconhecer o perfil do usuário e personalizar sua
        experiência. Caso o usuário não aceite os Cookies, sua experiência na plataforma será afetada.</p>

    <p class="title">Dados Pessoais Coletados, Tratados e Armazenados</p>
    <p class="mb-0">A Plataforma Estudei coleta, trata e armazena as seguintes informações:</p>
    <ul>
        <li>Informações fornecidas por você (nome, CPF, endereço, e-mail e telefone, dentre outros) no momento do
            cadastro ou posteriormente, via preenchimento de formulários ou em contatos diretos com a Plataforma
            Estudei, via e-mail, telefone, redes sociais ou outros canais de atendimento</li>
        <li>Foto do usuário para complementar seu perfil (opcional)</li>
        <li>Informações de navegação nos nossos sites (são coletadas informações como endereço IP,
            localização geográfica, tipo de navegador, duração da visita e páginas visitadas, dados de
            conexão, histórico de compras)</li>
        <li>Informações sobre você, seu uso dos nossos serviços e suas interações com nossa publicidade,
            como:
            <ul>
                <li>suas atividades na plataforma e preferências</li>
                <li>suas interações com nossos canais de comunicação e seus detalhes (como data, hora e motivo do
                    contato, transcrição de comunicação, o seu número de telefone e as gravações das chamadas)</li>
                <li>características de aparelhos e software, informações sobre a conexão, estatísticas sobre
                    visualizações de página, fonte encaminhadora, endereço IP, navegador e dados padrão de logs de
                    servidores da internet</li>
                <li>informações coletadas pelo uso de cookies, web beacons e outras tecnologias, incluindo dados de
                    anúncios</li>
            </ul>
        </li>
    </ul>

    <p>Os dados pessoais dos usuários podem ser mantidos pela Plataforma Estudei pelo tempo que for necessário para as
        respectivas finalidades e conforme exigido por lei ou regulamento ou para exercício regular de direitos.</p>
    <p>O usuário tem direitos e garantias em relação aos seus dados pessoais, como aqueles previstos na Lei Geral de
        Proteção de Dados (Lei 13.709/2018).</p>

    <p class="title">Guarda e Segurança das Informações</p>
    <p>As informações fornecidas pelos usuários serão obtidas e armazenadas de acordo com os mais rígidos padrões de
        segurança e confiabilidade. Envidaremos nossos melhores esforços na manutenção da integridade das informações
        que nos forem fornecidas, razão pela qual não somos responsáveis pelos danos decorrentes do seu acesso e/ou
        utilização por terceiros estranhos. O acesso às informações coletadas é restrito aos colaboradores e pessoas
        autorizadas.</p>
    <p>Aqueles que utilizarem indevidamente essas informações, em violação desta Política de Privacidade, estarão
        sujeitos a sanções civis e penais.</p>
    <p>Em nenhuma hipótese este site armazenará dados financeiros dos usuários (ex. dados de cartão de créditos, números
        de conta, etc.). Todo o processo de compra, via de regra, é feito através dos sistemas da hotmart que possui os
        mais altos níveis de segurança e se responsabiliza pela proteção dos dados necessários ao procedimento de
        compra.</p>
    <p>É de responsabilidade do usuário a guarda de sua senha e de seu login de acesso. Não é recomendada a utilização
        de senhas óbvias, como datas especiais, nomes ou sequências numéricas.
    </p>

    <p class="title">Uso e Finalidade dos Dados Coletados</p>
    <p class="mb-0">Os dados coletados pela Plataforma Estudei serão utilizados para as seguintes
        finalidades:</p>
    <ul>
        <li>realizar o cadastro e autenticação do usuário</li>
        <li>gerir suas assinaturas e compras</li>
        <li>realizar atividades de suporte, análise e prevenção à fraude na plataforma</li>
        <li>melhorias constantes na plataforma</li>
        <li>envio de newsletters relacionadas a temas de estudos e sobre o serviço (atualizações, dicas,
            funcionalidades e novos conteúdos disponíveis)</li>
        <li>comunicação de lançamento de novos materiais ou de produtos e serviços da plataforma Estudei
        </li>
        <li>determinar sua localização aproximada para oferecer recomendações personalizadas</li>
    </ul>
    <p>Os dados adquiridos poderão ser divulgados como pesquisas e estatísticas, não sendo reveladas abertamente nenhuma
        informação pessoal, a menos que autorizada explicitamente.</p>
    <p>Funcionários da Plataforma Estudei poderão eventualmente entrar em contato via e-mail, telefone ou outro meio
        digital para fazer pesquisas ou apresentar produtos e serviços até que você cancele o cadastro para o
        recebimento de tais informações através dos links disponíveis nos e-mails enviados.</p>
    <p>Salvo por determinação legal ou judicial, as informações dos usuários cadastrados neste Site jamais serão
        transferidas a terceiros ou usadas para finalidades diferentes daquelas para as quais foram coletadas.</p>

    <p class="title">Compartilhamento de Informações</p>
    <p class="mb-0">Os dados pessoais abaixo poderão estar disponíveis na plataforma:</p>
    <ul>
        <li>seu nome e/ou nome de usuário</li>
        <li>foto de perfil</li>
        <li>editais selecionados e cargos escolhidos</li>
        <li>medalhas e selos conquistados</li>
        <li>conteúdos públicos gerados por você</li>
    </ul>
    <p>Ao informar tais dados ou publicar conteúdos na plataforma você concorda em dar publicidade a
        tais dados, de forma gratuita e por tempo indeterminado.</p>

    <p class="title">Parceiros</p>
    <p>Na Plataforma Estudei o usuário poderá acessar links de outros portais ou plataformas parceiras, que poderão
        coletar suas informações conforme sua própria Política de Privacidade, que não são de responsabilidade da
        Plataforma Estudei.</p>

    <p class="title">Jurisdição</p>
    <p>Elege-se o Foro da Comarca do Espírito Santo para dirimir qualquer litígio ou controvérsia envolvendo o presente
        documento, salvo ressalva específica pela legislação aplicável.</p>

    <p class="title">Informações e Dúvidas</p>
    <p>Se, após a leitura desta Política, você ainda tiver qualquer dúvida, você pode entrar em contato pelo e-mail <a
            href="mailto:contato@estudei.com.br">contato&#64;estudei.com.br</a>. Ao entrar em contato
        conosco, para sua segurança e da Seedy, poderá ser necessário autenticar sua identidade antes de
        atender ao seu pedido.
    </p>

    <p class="text-right mt-5">Data da Última Atualização: 18 de janeiro de 2024</p>
</div>